import { useQuery } from "@tanstack/react-query";
import { useUserStore } from "@app/store/useUserStore";
import { userDivisionAccessQueryOptions } from "./userDivisionAccess.query";

/**
 * Возвращает Create-доступ для назначенных подразделений текущего пользователя.
 *
 * Результат общий для всех потребителей через TanStack Query cache. Повторный
 * запрос выполняется после устаревания данных или явного refresh.
 *
 * @param enabled включает загрузку capabilities
 */
export function useUserDivisionAccess(enabled = true) {
    const currentUser = useUserStore((state) => state.currentUser);
    const divisionCodes = currentUser?.DivisionCodes ?? [];

    return useQuery({
        ...userDivisionAccessQueryOptions(divisionCodes),
        enabled: enabled && currentUser != null,
    });
}
